import {
  ALL_NUMBER_OPERATORS,
  BackendFilter,
  FilterControlType,
  FilterOperator,
} from '@common/datatable/filters/backend-filter';
import {message} from '@ui/i18n/message';
import {
  createdAtFilter,
  updatedAtFilter,
} from '@common/datatable/filters/timestamp-filters';
import {UseFiltersReturn} from '@app/liens/use-link-filters';

export function TitlesDatatableFilters(
  filtersDefault: UseFiltersReturn | undefined,
): BackendFilter[] {
  const types = Object.values(filtersDefault?.types || {});
  return [
    {
      key: 'type',
      label: message('Type'),
      description: message('Whether title by type'),
      defaultOperator: FilterOperator.eq,
      control: {
        type: FilterControlType.Select,
        defaultValue: 'movie',
        options: types.map(type => ({
          key: type.id,
          value: type.id,
          label: type.name.charAt(0).toUpperCase() + type.name.slice(1),
        })),
      },
    },
    {
      key: 'views',
      label: message('Page views'),
      description: message('Number of unique page views'),
      defaultOperator: FilterOperator.lte,
      operators: ALL_NUMBER_OPERATORS,
      control: {
        type: FilterControlType.Input,
        inputType: 'number',
        minValue: 1,
        defaultValue: 100,
      },
    },
    {
      key: 'poster',
      label: message('No poster'),
      description: message('Whether title has a poster'),
      defaultOperator: FilterOperator.eq,
      control: {
        type: FilterControlType.BooleanToggle,
        defaultValue: null,
      },
    },
    createdAtFilter({
      description: message('Date title was created'),
    }),
    updatedAtFilter({
      description: message('Date title was last updated'),
    }),
  ];
}
